export default (state, getters, rootState) =>  {
    return state.article.filter(i => {
        return i.path === rootState.route.fullPath;
    });
}